import { useState } from 'react';
import { Topbar, Sidebar, Loader } from "../../../components";
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { show } from '../../../slices/toastSlice';
import { fetchRequests } from '../../../Requests/getRequests';
import { authStaff } from '../../../utils/constants';
import useConfigOptions from '../../../hooks/useConfigOptions';
import { useLoans } from '../../../hooks';
import { useNavigate } from 'react-router-dom';
import LoansTable from './AdminTable';
import { HugeiconsIcon } from '@hugeicons/react';
import { Money01Icon } from '@hugeicons/core-free-icons';

function Index() {

    const { loanStates } = useConfigOptions();
    const { isLoading, loans, metadata } = useLoans(
        { loanType: null, state: null, active: null, completed: false, rejected: false, endpoint: 'get-all-loans?loanType=cediscredit', page: 1 }
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [isPagLoading, setIsPagLoading] = useState(false);
    const [pagLoans, setPagLoans] = useState(null);
    const [pagMetadata, setPagMetadata] = useState(null);

    const loadingInc = isPagLoading || isLoading;

    const handlePagination = async (page) => {
        setIsPagLoading(true);

        const res = await fetchRequests(
            `/loans/staff/active-loans`, "GET",
            authStaff(accessToken),
            { state: loanStates.active, page: page || 1 }, {}
        );
        setIsPagLoading(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: res?.err }));
            return;
        }

        setPagLoans(res.loans);
        setPagMetadata(res.metadata);
    };

    return (
        <div className="main-container">
            <Topbar />
            <Sidebar />

            <main className="main-content">
                <section className="section-container space-y-6">

                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0">
                            <HugeiconsIcon icon={Money01Icon} size={18} className="text-amber-600" />
                        </div>
                        <div>
                            <div className="flex items-center gap-2">
                                <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Npontu Clients Payments</h1>
                                {(pagMetadata || metadata)?.totalCount > 0 && (
                                    <span className="px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-500 rounded-full">
                                        {(pagMetadata || metadata).totalCount}
                                    </span>
                                )}
                                {loadingInc && <Loader color="text-gray-400" size="w-4 h-4" />}
                            </div>
                            <p className="text-sm text-gray-400">Active CedisCredit loan clients</p>
                        </div>
                    </div>

                    <LoansTable
                        loans={pagLoans ?? loans}
                        metadata={pagMetadata ?? metadata}
                        handlePagination={handlePagination}
                    />

                </section>
            </main>
        </div>
    );
}

export default Index;
